(function () {
  function flavorColor(name) {
    var map = {
      'cookies & cream': '#F5F5F5',
      'grape soda': '#7D3C98',
      'blue raspberry': '#1F75FE',
      'vanilla iced coffee': '#E3D6B8',
      'mango candy': '#FFA500',
      'tropical punch': '#FF6F61',
      'peppermint mocha': '#AAF0D1',
      'loaded nacho': '#FFD700',
      'jalapeno cheddar': '#9ACD32',
      'jalapeño cheddar': '#9ACD32',
      'bbq': '#8B0000',
      'cheeseburger': '#C49E76',
      'flaming red hot': '#FF0000',
      'chocolate': '#7B3F00',
      'fruity puffs': '#FFD700',
      '3-pack': '#FFB6C1',
      '6-pack': '#87CEEB',
      'small': '#98FB98',
      'medium': '#FFD700',
      'large': '#FFA07A',
      'x-large': '#DA70D6',
      'black': '#000000',
      'blue': '#0000FF',
      'pink': '#FFC0CB',
      'chocolate sundae': '#8B4513',
      'java chip': '#4B3621',
      'peanut butter cup': '#C68642',
      'pb cup': '#C68642',
      'strawberry shortcake': '#FC5A8D',
      'banana split': '#FFE135'
    };
    return map[(name || '').toLowerCase().trim()] || '#CCC';
  }

  function setVariantButtonColor(button) {
    var name = (button.dataset.variantName || '').toLowerCase().trim();
    if (!name) return;

    if (name === 'banana split / banana split / tropical punch') {
      button.style.backgroundImage = '';
      button.style.backgroundColor = '#FAD02E';
      return;
    }
    if (name === 'banana split / banana split / blue raspberry') {
      button.style.backgroundImage = '';
      button.style.backgroundColor = '#4F86F7';
      return;
    }
    if (name === 'banana split / banana split / mango candy') {
      button.style.backgroundImage = '';
      button.style.backgroundColor = '#FFB84D';
      return;
    }

    var parts = name.split('/').map(function (part) { return part.trim(); }).filter(Boolean);
    if (parts.length === 2) {
      button.style.backgroundImage = 'linear-gradient(90deg, ' + flavorColor(parts[0]) + ', ' + flavorColor(parts[1]) + ')';
      button.style.backgroundColor = '';
      return;
    }

    button.style.backgroundImage = '';
    button.style.backgroundColor = flavorColor(name);
  }

  function formatVariantLabel(name) {
    var label = (name || '').trim();
    if (!label || label.toLowerCase() === 'default title') return '';

    var seen = {};
    return label.split('/').map(function (part) {
      var clean = part.trim();
      if (clean.toLowerCase() === 'peanut butter cup') clean = 'PB Cup';
      return clean;
    }).filter(function (part) {
      if (!part) return false;
      var key = part.toLowerCase();
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    }).join(' / ');
  }

  function getActiveCarousel(section) {
    return section.querySelector('.xeela-home-supplements__carousel.is-active');
  }

  function getCardsPerSlide() {
    return window.matchMedia('(max-width: 767px)').matches ? 2 : 4;
  }

  function getCarouselState(carousel) {
    if (!carousel.xeelaSupplementsState) {
      carousel.xeelaSupplementsState = { currentSlide: 0 };
    }
    return carousel.xeelaSupplementsState;
  }

  function getTotalSlides(carousel) {
    var cards = carousel.querySelectorAll('[data-xeela-supplements-card]');
    return Math.max(1, Math.ceil(cards.length / getCardsPerSlide()));
  }

  function updateCarousel(section, carousel) {
    if (!carousel) return;
    var track = carousel.querySelector('[data-xeela-supplements-track]');
    var cards = carousel.querySelectorAll('[data-xeela-supplements-card]');
    var progress = section.querySelector('[data-xeela-supplements-progress]');
    if (!track || !cards.length) {
      if (progress) progress.style.width = '100%';
      return;
    }

    var state = getCarouselState(carousel);
    var totalSlides = getTotalSlides(carousel);
    state.currentSlide = Math.max(0, Math.min(state.currentSlide, totalSlides - 1));

    var startIndex = state.currentSlide * getCardsPerSlide();
    var target = cards[startIndex] || cards[0];
    track.style.transform = 'translateX(-' + target.offsetLeft + 'px)';

    if (progress) {
      progress.style.width = ((state.currentSlide + 1) / totalSlides * 100) + '%';
    }

    var prev = section.querySelector('[data-xeela-supplements-prev]');
    var next = section.querySelector('[data-xeela-supplements-next]');
    if (prev) prev.disabled = state.currentSlide <= 0;
    if (next) next.disabled = state.currentSlide >= totalSlides - 1;
  }

  function activateTab(section, key) {
    section.querySelectorAll('[data-xeela-supplements-tab]').forEach(function (tab) {
      var active = tab.dataset.xeelaSupplementsTab === key;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    section.querySelectorAll('[data-xeela-supplements-carousel]').forEach(function (carousel) {
      var active = carousel.dataset.xeelaSupplementsCarousel === key;
      carousel.hidden = !active;
      carousel.classList.toggle('is-active', active);
      if (active) {
        getCarouselState(carousel).currentSlide = 0;
        updateCarousel(section, carousel);
      }
    });
  }

  function move(section, direction) {
    var carousel = getActiveCarousel(section);
    if (!carousel) return;
    var state = getCarouselState(carousel);
    state.currentSlide += direction;
    updateCarousel(section, carousel);
  }

  function initSection(section) {
    if (!section || section.dataset.xeelaSupplementsInitialized === 'true') return;
    section.dataset.xeelaSupplementsInitialized = 'true';

    section.querySelectorAll('[data-xeela-supplements-variant]').forEach(function (button) {
      setVariantButtonColor(button);
      button.addEventListener('click', function () {
        var card = button.closest('[data-xeela-supplements-card]');
        if (!card) return;

        card.querySelectorAll('[data-xeela-supplements-variant]').forEach(function (sibling) {
          sibling.classList.toggle('is-selected', sibling === button);
        });

        if (button.dataset.variantImage) {
          var image = card.querySelector('[data-xeela-supplements-product-image]');
          if (image) image.src = button.dataset.variantImage;
        }

        var name = card.querySelector('[data-xeela-supplements-variant-name]');
        if (name) name.textContent = formatVariantLabel(button.dataset.variantName);
      });
    });

    section.querySelectorAll('[data-xeela-supplements-add]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var card = button.closest('[data-xeela-supplements-card]');
        var selected = card ? card.querySelector('[data-xeela-supplements-variant].is-selected') : null;
        var id = selected ? selected.dataset.variantId : button.dataset.defaultVariantId;
        if (id) window.location.href = '/cart/add?id=' + encodeURIComponent(id) + '&quantity=1';
      });
    });

    section.querySelectorAll('[data-xeela-supplements-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(section, tab.dataset.xeelaSupplementsTab);
      });
    });

    var prev = section.querySelector('[data-xeela-supplements-prev]');
    var next = section.querySelector('[data-xeela-supplements-next]');
    if (prev) prev.addEventListener('click', function () { move(section, -1); });
    if (next) next.addEventListener('click', function () { move(section, 1); });

    section.xeelaSupplementsResize = function () {
      updateCarousel(section, getActiveCarousel(section));
    };
    window.addEventListener('resize', section.xeelaSupplementsResize);

    section.querySelectorAll('[data-xeela-supplements-carousel]').forEach(function (carousel) {
      var startX = 0;
      carousel.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
      }, { passive: true });
      carousel.addEventListener('touchend', function (event) {
        var delta = startX - event.changedTouches[0].clientX;
        if (Math.abs(delta) > 50) move(section, delta > 0 ? 1 : -1);
      }, { passive: true });
    });

    updateCarousel(section, getActiveCarousel(section));
  }

  function getSections(root) {
    var scope = root || document;
    var sections = [];
    if (scope.matches && scope.matches('[data-xeela-home-supplements]')) sections.push(scope);
    scope.querySelectorAll('[data-xeela-home-supplements]').forEach(function (section) {
      sections.push(section);
    });
    return sections;
  }

  function initAll(root) {
    getSections(root).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    getSections(event.target).forEach(function (section) {
      if (section.xeelaSupplementsResize) {
        window.removeEventListener('resize', section.xeelaSupplementsResize);
      }
    });
  });
})();
